import { Component } from '@angular/core';

@Component({
  selector: 'avs-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.css']
})
export class ImpressumComponent {

}
